function isFunction(fn: any): boolean {
    return fn instanceof Function;
}

// ----------------------------------------------------------------------------

export default isFunction;
